// Where a panel opened from a cell or a field goes (a calendar, a list): under it, never past the
// window's edges. Pure, so the checks can run it.

/** The room a panel keeps from the window's edges. */
export const VIEWPORT_MARGIN = 8;

/**
 * A panel `want` wide (else the anchor's width, at least 240) under an anchor: at most the window less
 * 16 px (a phone); from the anchor's left edge when it fits, else ending at its right edge (a cell or a
 * field near the right side), and in any case inside the window.
 */
export function floatBox(
  anchor: { left: number; right: number; width: number },
  want: number | undefined,
  viewport: number,
): { left: number; width: number } {
  const width = Math.min(want ?? Math.max(anchor.width, 240), viewport - 2 * VIEWPORT_MARGIN);
  const left = anchor.left + width <= viewport - VIEWPORT_MARGIN ? anchor.left : anchor.right - width;
  return { left: Math.max(VIEWPORT_MARGIN, Math.min(left, viewport - width - VIEWPORT_MARGIN)), width };
}
